var map = {
	"./ATB.png": 152,
	"./Mitutoyo2.png": 85,
	"./aws-logo.png": 153,
	"./itesm.png": 154,
	"./mitutoyo-logo.png": 155,
	"./mitutoyo.png": 156,
	"./oneila.png": 157,
	"./pedraza.png": 158,
	"./steren.png": 159,
	"./steren2.png": 160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 377;